module.exports = __webpack_public_path__ + "static/02-icon-93c8c008e2a362006fd796936a4c3687.png";